<template>
  <!-- 手机端首页 -->
  <div class="mh">
    <!-- logo图文标题 -->
    <div style="height:200px;">
      <div class="v_image">
        <div class="f20 font-weight">中国文艺网</div>
        <div class="f20 font-weight">视频资源数据展示应用平台</div>
      </div>
    </div>

    <!-- 顶部搜索栏 -->
    <div class="v_header">
      <el-row :gutter="20">
        <el-col :span="5">
          <div class="h_logo">
            <el-image style="width:50px;height:50px;vertical-align:middle;" class :src="logoUrl"></el-image>
          </div>
        </el-col>
        <el-col :span="12">
          <el-input v-model="searchValue" placeholder="名称/关键词/简介"></el-input>
        </el-col>
        <el-col :span="5">
          <el-button
            style="font-size:14px;"
            @click="mobileSearch"
            class="el-icon-search"
            type="primary"
            plain
          >搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 首页列表 -->
    <div class="list">
      <div class="flex-row nav-tab">
        <div
          @click="checkTab(index)"
          :class="[index == activeId ? 'nav-active':'']"
          v-for="(item,index) in navName"
          :id="index"
          :key="item.id"
        >{{item.name}}</div>
      </div>
      <!-- 小梅花 -->
      <div v-if="roleId == 6 || roleId == 7 || roleId == 8 || roleId == 9">
        <h3 style="padding:15px 10px;">小梅花</h3>
        <el-button style="margin-left:10px;" @click="goFlowsPage2" type="primary">跳转到小梅花列表页</el-button>

        <ul class="clearfloat" v-if="flowsList">
          <li
            class="fl"
            style="width:50%;padding:10px;height:200px;"
            v-for="item in flowsList.length>=2 ? flowsList.slice(0,2) : flowsList "
            :key="item.id"
            @click="goDetail(item.id)"
          >
            <div>
              <span class="txt-color1">{{otherList.totalTime}}分钟 / {{otherList.totalSize}}GB</span>
            </div>
            <el-image
              :src="item.fileLocation"
              style="width:100%;height:108px;border-radius:5px;border-radius:5px;"
            ></el-image>
            <p>{{item.fileName}}</p>
          </li>
        </ul>
      </div>
      <div class="typeVideoList">
        <ul class="clearfloat">
          <li v-if="newsList.videoInfoList">
            <h3>新闻类</h3>
            <div>
              <span class="txt-color1">{{newsList.totalTime}}分钟 / {{newsList.totalSize}}GB</span>
            </div>
            <el-image
              @click="goDetail(newsList.videoInfoList[0].id)"
              :src=" newsList.videoInfoList[0].fileLocation"
              style="width:100%;height:108px;border-radius:5px;"
              fit="cover"
            ></el-image>
            <p>{{newsList.videoInfoList[0].fileIntro}}</p>
          </li>
          <li v-if="liveList.videoInfoList">
            <h3>直播类</h3>
            <div>
              <span class="txt-color1">{{liveList.totalTime}}分钟 / {{liveList.totalSize}}GB</span>
            </div>
            <el-image
              @click="goDetail(liveList.videoInfoList[0].id)"
              :src=" liveList.videoInfoList[0].fileLocation"
              style="width:100%;height:108px;border-radius:5px;"
            ></el-image>
            <p>{{liveList.videoInfoList[0].fileIntro}}</p>
          </li>
          <li v-if="viewList.videoInfoList">
            <h3>访谈类</h3>
            <div>
              <span class="txt-color1">{{viewList.totalTime}}分钟 / {{viewList.totalSize}}GB</span>
            </div>
            <el-image
              @click="goDetail(viewList.videoInfoList[0].id)"
              :src=" viewList.videoInfoList[0].fileLocation"
              style="width:100%;height:108px;border-radius:5px;"
            ></el-image>
            <p>{{viewList.videoInfoList[0].fileIntro}}</p>
          </li>
          <li v-if="workList.videoInfoList">
            <h3>作品类</h3>
            <div>
              <span class="txt-color1">{{workList.totalTime}}分钟 / {{workList.totalSize}}GB</span>
            </div>
            <el-image
              @click="goDetail(workList.videoInfoList[0].id)"
              :src=" workList.videoInfoList[0].fileLocation"
              style="width:100%;height:108px;border-radius:5px;"
            ></el-image>
            <p>{{workList.videoInfoList[0].fileIntro}}</p>
          </li>
        </ul>
      </div>
      <div>
        <!-- 其他类 -->
        <h3 style="padding:15px 10px;">其他类</h3>
        <ul class="clearfloat" v-if="otherList.videoInfoList">
          <li
            class="fl"
            style="width:50%;padding:10px;height:250px;"
            v-for="item in otherList.videoInfoList.length>=2 ? otherList.videoInfoList.slice(0,2) : otherList.videoInfoList "
            :key="item.id"
            @click="goDetail(item.id)"
          >
            <div>
              <span class="txt-color1">{{otherList.totalTime}}分钟 / {{otherList.totalSize}}GB</span>
            </div>
            <el-image
              :src="item.fileLocation"
              style="width:100%;height:108px;border-radius:5px;border-radius:5px;"
            ></el-image>
            <p>{{item.fileIntro}}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 平台视频数据总量 -->
    <div style="margin-top:2rem;">
      <!-- 标题 -->
      <div class="data-title tac">
        <el-image style="width:27px;height:27px;" :src="dataLogo"></el-image>
        <h2>平台视频数据总量</h2>
        <div>TOTAL PLANTFORM DATA</div>
      </div>
      <div class="data-tab clearfloat">
        <div class="tab-box">
          <div class="tab-img bg-time">
            <el-image :src="timeSrc"></el-image>
          </div>
          <div style="padding:10px 15px;text-align:left;">
            <div style="font-size:20px;font-weight:bold;">{{videoGrossCount.videoTime}}</div>
            <div class="txt-color1 f12">视频总长（分钟）</div>
          </div>
        </div>
        <div class="tab-box">
          <div class="tab-img bg-size">
            <el-image :src="sizeSrc"></el-image>
          </div>
          <div style="padding:10px 15px;text-align:left;">
            <div style="font-size:20px;font-weight:bold;">{{videoGrossCount.videoSize}}</div>
            <div class="txt-color1 f12">视频总体积（{{videoGrossCount.SizeUnit}}）</div>
          </div>
        </div>
        <div class="tab-box">
          <div class="tab-img bg-total">
            <el-image :src="totalSrc"></el-image>
          </div>
          <div style="padding:10px 15px;text-align:left;">
            <div style="font-size:20px;font-weight:bold;">{{videoGrossCount.videoCount}}</div>
            <div class="txt-color1 f12">视频总数量（个）</div>
          </div>
        </div>
        <div class="tab-box">
          <div class="tab-img bg-video">
            <el-image :src="videoSrc"></el-image>
          </div>
          <div style="padding:10px 10px;text-align:left;">
            <div style="font-size:20px;font-weight:bold;">{{videoGrossCount.videoViewCount}}</div>
            <div class="txt-color1 f12">视频总播放量（次）</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div>
      <!-- 重点门类视频数量 -->
      <div class="pieCart">
        <div id="onecart" :style="{width:'100%',height:'40rem'}"></div>
      </div>
      <el-row style="margin:10px;" :gutter="10">
        <el-col :span="12">
          <div id="twocart" :style="{width:'100%',height:'45rem',background:'#fff'}"></div>
        </el-col>
        <el-col :span="12">
          <div id="threecart" :style="{width:'100%',height:'45rem',background:'#fff'}"></div>
        </el-col>
      </el-row>
    </div>
    <!-- 搜索量，播放量，下载量 -->
    <div style="background:#fff;padding:20px 10px;">
      <!-- tab切换栏 -->
      <div class="top_nav">
        <div
          @click="checkRankTab($event,index)"
          :class="[nn,'rank'+index == rid ?'ranlActive':'']"
          v-for="(item,index) in titleArray"
          :id="['rank'+ index]"
          :key="item.id"
        >
          <el-image
            style="pointer-events: none;width:20px;height:20px;vertical-align:middle;"
            :src="item.src"
          ></el-image>
          <span style="vertical-align:middle;pointer-events: none;font-size:14px;">{{item.title}}</span>
          <span style="font-size:12px;color:#778493;pointer-events: none;">热数据排行榜</span>
          <!-- <span style="color:#637283;font-size:16px;pointer-events: none;" v-if="index==id" class="fr">MORE &gt;</span> -->
        </div>
        <!-- <div @click="checkTab" id="" class="nn ">成片库</div>
        <div @click="checkTab" class="nn">素材库</div>-->
      </div>
      <!-- 图片列表 -->
      <ul class="top_name">
        <li
          :id="index"
          @click="checkTopTab"
          :class="[topId == index ? 'topActive':'']"
          v-for="(item,index) in topTab"
          :key="item.id"
        >{{item.name}}</li>
      </ul>
      <!-- 搜索量Top -->
      <div v-if="topId == 0" class="top-box">
        <ul>
          <li class="top-li" v-for="(item,index) in searchCount" :key="item.id">
            <div class="li-img">
              <el-image @click="goDetail(item.id)" fit="cover" :src="item.fileLocation"></el-image>
              <div
                :class="[linum,index == 0|| index == 1 || index == 2?bgYellow:'bg-gary']"
              >{{index + 1}}</div>
            </div>
            <div class="li-text">
              <h3 class="red">{{item.viewcount}}</h3>
              <h4>{{item.orgName}}</h4>
              <div class="text-color f14">数据源：{{item.videoType == 1 ?'成片库':'素材库'}}</div>
              <div class="text-color f14">格式：{{item.fileType}} / 时长：{{item.filePlayTime}}</div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 播放量 -->
      <div v-if="topId == 1" class="top-box">
        <ul>
          <li class="top-li" v-for="(item,index) in playList" :key="item.id">
            <div class="li-img">
              <el-image @click="goDetail(item.id)" fit="cover" :src="item.fileLocation"></el-image>
              <div
                :class="[linum,index == 0|| index == 1 || index == 2?bgYellow:'bg-gary']"
              >{{index + 1}}</div>
            </div>
            <div class="li-text">
              <h3 class="red">{{item.playcount}}</h3>
              <h4>{{item.orgName}}</h4>
              <div class="text-color f14">数据源：{{item.videoType == 1 ?'成片库':'素材库'}}</div>
              <div class="text-color f14">格式：{{item.fileType}} / 时长：{{item.filePlayTime}}</div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 下载量 -->
      <div v-if="topId == 2" class="top-box">
        <ul>
          <li class="top-li" v-for="(item,index) in dowloadList" :key="item.id">
            <div class="li-img">
              <el-image @click="goDetail(item.id)" fit="cover" :src="item.fileLocation"></el-image>
              <div
                :class="[linum,index == 0|| index == 1 || index == 2?bgYellow:'bg-gary']"
              >{{index + 1}}</div>
            </div>
            <div class="li-text">
              <h3 class="red">{{item.downloads}}</h3>
              <h4>{{item.orgName}}</h4>
              <div class="text-color f14">数据源：{{item.videoType == 1 ?'成片库':'素材库'}}</div>
              <div class="text-color f14">格式：{{item.fileType}} / 时长：{{item.filePlayTime}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 平台内容纬度总量 -->
    <div style="margin-top:2rem;">
      <!-- 标题 -->
      <div class="data-title tac">
        <el-image style="width:27px;height:27px;" :src="rankLogo"></el-image>
        <h2>平台内容纬度总量</h2>
        <div>TOTAL PLANTFORM DATA</div>
      </div>
      <!-- 图表 -->

      <div class="platdata" style>
        <div
          class="plat-top-nav"
          style="display:flex;flex-direction:row;justify-content:space-around;"
        >
          <div
            :class="['pl-tab',colorTxt == 0 ? 'bgc-white' : 'bg-tab']"
            ref="tagNum"
            @click="checkedCharts"
          >
            <div>视频标签总量</div>
            <div>
              <span :class="[colorTxt == 0 ? 'txtColor' : '']">{{videoGrossCount.videoTagsCount}}</span> 次
            </div>
          </div>
          <div
            @click="checkVideoPerson"
            :class="['pl-tab',colorTxt == 1 ? 'bgc-white' : 'bg-tab']"
            ref="personNum"
          >
            <div>视频人物总量</div>
            <div>
              <span :class="[colorTxt == 1 ? 'txtColor' : '']">{{videoGrossCount.videoPersonCount}}</span> 人次
            </div>
          </div>
        </div>
        <!-- <el-card class="plat-chart"> -->
        <div class="plat-chart" id="myPlatChart" :style="{width: '100%', height: '400px'}"></div>
        <!-- </el-card> -->

        <div
          class="plat-top-nav"
          style="display:flex;flex-direction:row;justify-content:space-around;"
        >
          <div
            @click="checkWord"
            :class="['pl-tab',colorTxt == 2 ? 'bgc-white' : 'bg-tab']"
            ref="videoWord"
          >
            <div>主办单位上传数量</div>
            <div>
              <span :class="[colorTxt == 2 ? 'txtColor' : '']">{{videoGrossCount.videoCharCount}}</span> 个
            </div>
          </div>
          <div
            @click="checkAddress"
            :class="['pl-tab',colorTxt == 3 ? 'bgc-white' : 'bg-tab']"
            ref="videoAddress"
          >
            <div>涉及地区地点总量</div>
            <div>
              <span :class="[colorTxt == 3 ? 'txtColor' : '']">{{videoGrossCount.videoAddressCount}}</span> 个
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <Mfooter />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Mfooter from '../footer/mfooter'
export default {
  components: {
    Mfooter
  },
  data: function () {
    return {
      searchValue: '',
      logoUrl: require('../../assets/img/logo2.png'),
      rankLogo: require('../../assets/img/icon/rank.png'),
      dataLogo: require('../../assets/img/icon/base.png'),
      timeSrc: require('../../assets/img/icon/time.png'),
      sizeSrc: require('../../assets/img/icon/size.png'),
      totalSrc: require('../../assets/img/icon/total.png'),
      videoSrc: require('../../assets/img/icon/play.png'),
      navName: [
        {
          id: 1,
          name: '成品库'
        },
        {
          id: 0,
          name: '素材库'
        }

      ],
      titleArray: [
        {
          id: 1,
          title: '成片库',
          src: require('../../assets/img/icon/video.png'),
          engname: 'MATERIAL LIBRARY'
        },
        {
          id: 0,
          title: '素材库',
          src: require('../../assets/img/icon/sucai.png'),
          engname: 'FINISHED PRODUCT LIBRARY'
        }

      ],
      activeId: 0,
      id: 0,
      rid: 'rank0',
      nn: 'nn',
      //   videoTypeId: 0, // 0=素材 1=成片
      // otherList: this.$store.state.otherList, // 其他类
      // newsList: this.$store.state.newsList, // 新闻类
      // viewList: this.$store.state.viewList, // 访谈类
      // workList: this.$store.state.workList, //作品类
      // liveList: this.$store.state.liveList //直播类
      topTab: [
        {
          id: 0,
          name: '搜索量TOP'
        },
        {
          id: 1,
          name: '播放量'
        },
        {
          id: 2,
          name: '下载量'
        }
      ],
      topId: 0,
      // 搜索量
      linum: 'li-num',
      bgYellow: 'bg-yellow',
      // 平台散点图
      nodes: [],
      edges: [],
      tagType: 0,
      piedata: {},
      colorTxt: 0,
      flowsList: [], //小梅花视频列表
       roleId: '',//角色id
    }
  },
  computed: mapState({
    otherList: 'otherList',
    newsList: 'newsList',
    viewList: 'viewList',
    workList: 'workList',
    liveList: 'liveList',
    videoGrossCount: 'videoGrossCount',
    searchCount: 'searchCount', // 搜索量
    playList: 'playList', // 播放量
    dowloadList: 'dowloadList', // 下载量
     
  }),
  methods: {
     // 获取 小梅花 视频列表
    getFlowsList: async function() {
      var res = await this.$http.get(`/v1/videoInfo/getPrizeList?page=1&category=`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.flowsList = data;

        // console.log("////////////", data);
      }
    },
    goFlowsPage2() {
      this.$router.push({
        path: "/mobileflowpage",
        query: {
          type: "flow"
        }
      });
    },
    // 查看详情，首页查看详情的都是单视频
    goDetail: async function (id) {
      var res = await this.$http.post(`/v1/videoInfo/videoStatus?id=${id}`)
      var { code, message, data } = res.data
      if (code == 0) {
        this.$router.push({
          path: '/mobvideodetail',
          query: {
            id: id,
            status: 0
          }
        })
      } else {
        this.$layer.toast({
          icon: 'icon-check', // 图标clssName 如果为空 toast位置位于下方,否则居中
          content: message,
          time: 1000 // 自动消失时间 toast类型默认消失时间为2000毫秒
        })
      }
    },
    // 搜索量播放量下载量切换
    checkTopTab: function (e) {
      console.log(e)
      this.topId = e.target.id
    },
    checkRankTab: function (e, index) {
      this.rid = e.target.id
      // this.videoTypeId = index;
      var typeId = index === 0 ? 1 : 0
      this.$store.commit('changeTypeId', typeId)
      this.$store.dispatch('getListByTop')
    },
    mobileSearch: function () {
      if (this.searchValue == '') {
        this.$layer.toast({
          icon: 'icon-check', // 图标clssName 如果为空 toast位置位于下方,否则居中
          content: '请输入搜索内容',
          time: 1000 // 自动消失时间 toast类型默认消失时间为2000毫秒
        })
      } else {
        this.$router.push({
          path: '/highsearch',
          query: {
            value: this.searchValue
          }
        })
      }
    },
    checkTab: function (id) {
      this.activeId = id
      let typeId = id === 0 ? 1 : 0
      this.$store.commit('changeTypeId', typeId)
      this.$store.dispatch('getListByContent')
    },
    // 绘制图标
    creatCart: function () {
      var that = this
      var chartPie = this.$echarts.init(document.getElementById('onecart'))
      var myChart1 = this.$echarts.init(document.getElementById('twocart'))
      var myChart2 = this.$echarts.init(document.getElementById('threecart'))
      // 重点门类视频数量
      chartPie.setOption(
        {
          title: {
            text: '重点门类视频数量',
            subtext: '',
            x: 'center'
          },
          tooltip: {
            trigger: 'item',
            // formatter: "{a} <br/>{b} : {c} ({d}%)"
            formatter: function (params) {
              var res = params.name + ':' + params.percent + '%' + '<br />'
              // var res = ''
              // console.log("ppp", params);
              return res
            }
          },
          legend: {
            x: 'center',
            y: 'bottom',
            // type: 'scroll',
            // orient: 'vertical',
            // right:10,
            // top: 60,
            // bottom: 20,
            data: (function () {
              var arr = []
              // console.log(that.videoGrossCount.categoryCount)
              that.videoGrossCount.categoryCount.forEach(item => {
                // console.log('iiiii',item)
                arr.push(item.category)
              })
              // for(var i = 0;i<that.videoGrossCount.categoryCount;i++){
              //   console.log('iiiii',that.videoInfoGrossCount.categoryCount[i])
              //   // arr.push(i.category)
              // }
              // console.log('aaaaa',arr)
              return arr
            })()
          },
          // toolbox: {
          //   show: true,
          //   feature: {
          //     mark: { show: true },
          //     dataView: { show: true, readOnly: false },
          //     magicType: {
          //       show: true,
          //       type: ["pie", "funnel"]
          //     },
          //     restore: { show: true },
          //     saveAsImage: { show: true }
          //   }
          // },
          calculable: true,
          dataset: {
            source: that.videoGrossCount.categoryCount
          },
          series: [
            {
              name: '半径模式',
              type: 'pie',
              // radius: [0, 140],
              radius: '80%',
              center: ['50%', '38%'],
              // roseType: "angle",
              // roseType: "radius",
              label: {
                normal: {
                  // 显示数据
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
              lableLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
              encode: {
                itemName: 'category',
                value: 'videocount'
              },
              // data: [
              //   { value: 20, name: "文学" },
              //   { value: 28, name: "戏曲" },
              //   { value: 12, name: "电影" },
              //   { value: 10, name: "音乐" },
              //   { value: 11, name: "曲艺" },
              //   { value: 19, name: "舞蹈" }
              // ],
              // data: that.videoGrossCount.categoryCount,
              // 自定义颜色的实现
              itemStyle: {
                normal: {
                  // 定义一个list，通过list获取颜色，
                  color: function (params) {
                    var colorList = [
                      '#7f68f6',
                      '#2cd9c5',
                      '#505d6f',
                      '#2d98fe',
                      '#ff6c40',
                      '#fee600',

                      '#37a2da',
                      '#32c5e9',
                      '#9fe6b8',
                      '#ffdb5c',
                      '#ff9f7f',
                      '#fb7293',

                      '#e7bcf3',
                      '#8378ea',

                      '#505d6f',
                      '#2d98fe',
                      '#ff6c40',
                      '#fee600'
                    ]
                    return colorList[params.dataIndex]
                  },
                  // 以下为是否显示，显示位置和显示格式
                  label: {
                    show: true,

                    position: 'top',
                    //                             formatter: '{c}'
                    // formatter: "{b}\n{c}"
                    formatter: function (params) {
                      var res = params.name + ' : ' + params.data.videocount
                      return res
                    }
                  }
                }
              }
            }
            // {
            //   name: "面积模式",
            //   type: "pie",
            //   radius: [30, 110],
            //   center: ["75%", "50%"],
            //   roseType: "area",
            //   data: [
            //     { value: 10, name: "rose1" },
            //     { value: 5, name: "rose2" },
            //     { value: 15, name: "rose3" },
            //     { value: 25, name: "rose4" },
            //     { value: 20, name: "rose5" },
            //     { value: 35, name: "rose6" },
            //     { value: 30, name: "rose7" },
            //     { value: 40, name: "rose8" }
            //   ]
            // }
          ]
        },
        true
      )
      // 重点门类浏览数量
      myChart1.setOption(
        {
          // ----------
          color: ['#00aaff'],
          title: { text: '重点门类浏览总量', x: 'center' },
          dataset: {
            source: that.videoGrossCount.categoryCount
            // source: [
            //   {
            //     category: "书法",
            //     downloads: 6,
            //     proportion: 0,
            //     videocount: "3",
            //     viewcount: 13
            //   },
            //   {
            //     category: "戏剧",
            //     downloads: 2,
            //     proportion: 0,
            //     videocount: "1",
            //     viewcount: 27
            //   }
            // ]
          },
          // 到处图片
          // toolbox: {
          //   show: true,
          //   feature: {
          //     dataView: { readOnly: false },
          //     restore: {},
          //     saveAsImage: {}
          //   }
          // },
          grid: { containLabel: true },
          tooltip: {},
          xAxis: {
            show: true,
            // axisLabel: {
            //   inside: true,
            // },
            axisLabel: 'false',
            axisLine: {
              // x轴
              show: false
            },
            axisTick: {
              // x轴刻度线
              show: false
            },
            splitLine: {
              // 网格线
              show: true
            }
          },
          yAxis: {
            show: true,
            splitLine: {
              show: true
            },
            axisTick: {
              show: false
            },
            type: 'category'
            // data: ["文学", "戏曲", "电影", "音乐", "曲艺", "舞蹈"]
          },
          series: [
            {
              type: 'bar',
              encode: {
                x: 'viewcount',
                y: 'product'
              },
              name: '',
              // data: [133, 244, 355, 433, 54, 655, 733],
              label: {
                normal: {
                  show: true,
                  position: 'insideLeft'
                }
              }
            }
          ]
        },
        true
      )
      // 重点门类下载总量图表
      myChart2.setOption(
        {
          color: ['#00aaff'],
          title: { text: '本月上传总量', x: 'center' },
          tooltip: {},
          dataset: {
            source: that.videoGrossCount.categoryCount
          },
          grid: { containLabel: true },
          xAxis: {
            // axisLabel: {
            //   inside: false,
            //   textStyle: {
            //     color: "#fff"
            //   }
            // },
            axisLabel: 'false',
            splitLine: {
              show: true
            },
            axisTick: {
              show: false
            }
          },
          yAxis: {
            splitLine: {
              show: true
            },
            axisTick: {
              show: false
            },
            type: 'category'
            // data: []
          },
          series: [
            {
              type: 'bar',
              encode: {
                x: 'downloads',
                y: 'category'
              },
              name: '下载量',
              label: {
                normal: {
                  show: true,
                  position: 'insideLeft'
                }
              }
              // data: [1, 2, 3, 4, 5, 6, 7]
            }
          ]
        },
        true
      )
    },
    // 平台内容纬度
    checkedCharts: function () {
      this.colorTxt = 0
      this.getTagChart()
    },
    checkVideoPerson: function () {
      this.colorTxt = 1
      this.getTagChart()
    },
    checkWord: function () {
      this.colorTxt = 2
      this.getTagChart()
    },
    checkAddress: function () {
      this.colorTxt = 3
      this.getTagChart()
    },
    initPlat: function () {
      var that = this
      var myPlatChart = this.$echarts.init(
        document.getElementById('myPlatChart')
      )
      if (this.colorTxt == 0) {
        myPlatChart.setOption(
          {
            title: {
              // text: "视频标签关系图",
              x: 'left'
            },
            animationDurationUpdate: 1500,
            animationEasingUpdate: 'quinticInOut',
            series: [
              {
                type: 'graph',
                layout: 'none',
                // progressiveThreshold: 700,
                data: that.nodes.map(function (node) {
                  return {
                    x: node.x,
                    y: node.y,
                    id: node.id,
                    name: node.label,
                    symbolSize: node.size,
                    itemStyle: {
                      normal: {
                        color: node.color
                      }
                    }
                  }
                }),
                edges: that.edges.map(function (edge) {
                  return {
                    source: edge.sourceID,
                    target: edge.targetID
                  }
                }),
                label: {
                  emphasis: {
                    position: 'right',
                    show: true
                  }
                },
                roam: true,
                focusNodeAdjacency: true,
                lineStyle: {
                  normal: {
                    width: 0.5,
                    curveness: 0.3,
                    opacity: 0.7
                  }
                }
              }
            ]
          },
          true
        )
      } else if (this.colorTxt == 1) {
        console.log('11222')
        myPlatChart.setOption(
          {
            title: {
              // text: "重点门类视频数量",
              subtext: '',
              x: 'left'
            },
            tooltip: {
              trigger: 'item',
              // formatter: "{a} <br/>{b} : {c} ({d}%)"
              formatter: function (params) {
                var res = params.name + ':' + params.percent + '%' + '<br />'
                // var res = ''
                // console.log("ppp", params);
                return res
              }
            },
            legend: {
              x: 'center',
              y: 'bottom',
              // type: 'scroll',
              // orient: 'vertical',
              // right:10,
              // top: 60,
              // bottom: 20,
              data: (function () {
                var arr = []
                // console.log(that.videoGrossCount.categoryCount)
                that.piedata.forEach(item => {
                  // console.log('iiiii',item)
                  arr.push(item.name)
                })
                // for(var i = 0;i<that.videoGrossCount.categoryCount;i++){
                //   console.log('iiiii',that.videoInfoGrossCount.categoryCount[i])
                //   // arr.push(i.category)
                // }
                // console.log('aaaaa',arr)
                return arr
              })()
            },
            //   toolbox: {
            //     show: true,
            //     feature: {
            //       magicType: {
            //         show: true,
            //         type: ["pie", "funnel"]
            //       },
            //       saveAsImage: { show: true }
            //     }
            //   },
            calculable: true,
            dataset: {
              source: that.piedata
            },
            series: [
              {
                name: '半径模式',
                type: 'pie',
                // radius: [50, 120],
                radius: '70%',
                center: ['50%', '35%'],
                // roseType: "angle",//南丁格尔图
                // roseType: "radius",//分块
                // roseType: "single", // 整圆
                label: {
                  normal: {
                    // 显示数据
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                lableLine: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                encode: {
                  itemName: 'name',
                  value: 'value'
                },
                // data: [
                //   { value: 20, name: "文学" },
                //   { value: 28, name: "戏曲" },
                //   { value: 12, name: "电影" },
                //   { value: 10, name: "音乐" },
                //   { value: 11, name: "曲艺" },
                //   { value: 19, name: "舞蹈" }
                // ],
                // data: that.videoGrossCount.categoryCount,
                // 自定义颜色的实现
                itemStyle: {
                  normal: {
                    // 定义一个list，通过list获取颜色，
                    color: function (params) {
                      var colorList = [
                        '#7f68f6',
                        '#2cd9c5',
                        '#505d6f',
                        '#2d98fe',
                        '#ff6c40',
                        '#fee600',

                        '#37a2da',
                        '#32c5e9',
                        '#9fe6b8',
                        '#ffdb5c',
                        '#ff9f7f',
                        '#fb7293',

                        '#e7bcf3',
                        '#8378ea',

                        '#505d6f',
                        '#2d98fe',
                        '#ff6c40',
                        '#fee600'
                      ]
                      return colorList[params.dataIndex]
                    },
                    // 以下为是否显示，显示位置和显示格式
                    label: {
                      show: true,

                      position: 'top',
                      //                             formatter: '{c}'
                      // formatter: "{b}\n{c}"
                      formatter: function (params) {
                        var res = params.name + ' : ' + params.data.value
                        return res
                      }
                    }
                  }
                }
              }
              // {
              //   name: "面积模式",
              //   type: "pie",
              //   radius: [30, 110],
              //   center: ["75%", "50%"],
              //   roseType: "area",
              //   data: [
              //     { value: 10, name: "rose1" },
              //     { value: 5, name: "rose2" },
              //     { value: 15, name: "rose3" },
              //     { value: 25, name: "rose4" },
              //     { value: 20, name: "rose5" },
              //     { value: 35, name: "rose6" },
              //     { value: 30, name: "rose7" },
              //     { value: 40, name: "rose8" }
              //   ]
              // }
            ]
          },
          true
        )
      } else if (this.colorTxt == 2) {
        myPlatChart.setOption(
          {
            title: {
              // text: "重点门类视频数量",
              subtext: '',
              x: 'left'
            },
            tooltip: {
              trigger: 'item',
              // formatter: "{a} <br/>{b} : {c} ({d}%)"
              formatter: function (params) {
                var res = params.name + ':' + params.percent + '%' + '<br />'
                // var res = ''
                // console.log("ppp", params);
                return res
              }
            },
            legend: {
              x: 'center',
              y: 'bottom',
              // type: 'scroll',
              // orient: 'vertical',
              // right:10,
              // top: 60,
              // bottom: 20,
              data: (function () {
                var arr = []
                // console.log(that.videoGrossCount.categoryCount)
                that.piedata.forEach(item => {
                  // console.log('iiiii',item)
                  arr.push(item.name)
                })
                // for(var i = 0;i<that.videoGrossCount.categoryCount;i++){
                //   console.log('iiiii',that.videoInfoGrossCount.categoryCount[i])
                //   // arr.push(i.category)
                // }
                // console.log('aaaaa',arr)
                return arr
              })()
            },
            //   toolbox: {
            //     show: true,
            //     feature: {
            //       magicType: {
            //         show: true,
            //         type: ["pie", "funnel"]
            //       },
            //       saveAsImage: { show: true }
            //     }
            //   },
            calculable: true,
            dataset: {
              source: that.piedata
            },
            series: [
              {
                name: '半径模式',
                type: 'pie',
                // radius: [50, 180],
                // radius: "70%",
                center: ['50%', '35%'],
                // roseType: "angle",//南丁格尔图
                roseType: 'radius', // 分块
                // roseType:'single',// 整圆
                label: {
                  normal: {
                    // 显示数据
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                lableLine: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                encode: {
                  itemName: 'name',
                  value: 'value'
                },
                // data: [
                //   { value: 20, name: "文学" },
                //   { value: 28, name: "戏曲" },
                //   { value: 12, name: "电影" },
                //   { value: 10, name: "音乐" },
                //   { value: 11, name: "曲艺" },
                //   { value: 19, name: "舞蹈" }
                // ],
                // data: that.videoGrossCount.categoryCount,
                // 自定义颜色的实现
                itemStyle: {
                  normal: {
                    // 定义一个list，通过list获取颜色，
                    color: function (params) {
                      var colorList = [
                        '#7f68f6',
                        '#2cd9c5',
                        '#505d6f',
                        '#2d98fe',
                        '#ff6c40',
                        '#fee600',

                        '#37a2da',
                        '#32c5e9',
                        '#9fe6b8',
                        '#ffdb5c',
                        '#ff9f7f',
                        '#fb7293',

                        '#e7bcf3',
                        '#8378ea',

                        '#505d6f',
                        '#2d98fe',
                        '#ff6c40',
                        '#fee600'
                      ]
                      return colorList[params.dataIndex]
                    },
                    // 以下为是否显示，显示位置和显示格式
                    label: {
                      show: true,

                      position: 'top',
                      //                             formatter: '{c}'
                      // formatter: "{b}\n{c}"
                      formatter: function (params) {
                        var res = params.name + ' : ' + params.data.value
                        return res
                      }
                    }
                  }
                }
              }
              // {
              //   name: "面积模式",
              //   type: "pie",
              //   radius: [30, 110],
              //   center: ["75%", "50%"],
              //   roseType: "area",
              //   data: [
              //     { value: 10, name: "rose1" },
              //     { value: 5, name: "rose2" },
              //     { value: 15, name: "rose3" },
              //     { value: 25, name: "rose4" },
              //     { value: 20, name: "rose5" },
              //     { value: 35, name: "rose6" },
              //     { value: 30, name: "rose7" },
              //     { value: 40, name: "rose8" }
              //   ]
              // }
            ]
          },
          true
        )
      } else {
        console.log('333333')
        myPlatChart.setOption(
          {
            title: {
              // text: "重点门类视频数量",
              subtext: '',
              x: 'left'
            },
            tooltip: {
              trigger: 'item',
              // formatter: "{a} <br/>{b} : {c} ({d}%)"
              formatter: function (params) {
                var res = params.name + ':' + params.percent + '%' + '<br />'
                // var res = ''
                // console.log("ppp", params);
                return res
              }
            },
            legend: {
              x: 'center',
              y: 'bottom',
              // type: 'scroll',
              // orient: 'vertical',
              // right:10,
              // top: 60,
              // bottom: 20,
              data: (function () {
                var arr = []
                // console.log(that.videoGrossCount.categoryCount)
                that.piedata.forEach(item => {
                  // console.log('iiiii',item)
                  arr.push(item.name)
                })
                // for(var i = 0;i<that.videoGrossCount.categoryCount;i++){
                //   console.log('iiiii',that.videoInfoGrossCount.categoryCount[i])
                //   // arr.push(i.category)
                // }
                // console.log('aaaaa',arr)
                return arr
              })()
            },
            //   toolbox: {
            //     show: true,
            //     feature: {
            //       magicType: {
            //         show: true,
            //         type: ["pie", "funnel"]
            //       },
            //       saveAsImage: { show: true }
            //     }
            //   },
            calculable: true,
            dataset: {
              source: that.piedata
            },
            series: [
              {
                name: '半径模式',
                type: 'pie',
                radius: [50, 120],
                // radius: "70%",
                center: ['50%', '35%'],
                // roseType: "angle",//南丁格尔图
                // roseType: "radius",//分块
                // roseType: "single", // 整圆
                label: {
                  normal: {
                    // 显示数据
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                lableLine: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                encode: {
                  itemName: 'name',
                  value: 'value'
                },
                // data: [
                //   { value: 20, name: "文学" },
                //   { value: 28, name: "戏曲" },
                //   { value: 12, name: "电影" },
                //   { value: 10, name: "音乐" },
                //   { value: 11, name: "曲艺" },
                //   { value: 19, name: "舞蹈" }
                // ],
                // data: that.videoGrossCount.categoryCount,
                // 自定义颜色的实现
                itemStyle: {
                  normal: {
                    // 定义一个list，通过list获取颜色，
                    color: function (params) {
                      var colorList = [
                        '#7f68f6',
                        '#2cd9c5',
                        '#505d6f',
                        '#2d98fe',
                        '#ff6c40',
                        '#fee600',

                        '#37a2da',
                        '#32c5e9',
                        '#9fe6b8',
                        '#ffdb5c',
                        '#ff9f7f',
                        '#fb7293',

                        '#e7bcf3',
                        '#8378ea',

                        '#505d6f',
                        '#2d98fe',
                        '#ff6c40',
                        '#fee600'
                      ]
                      return colorList[params.dataIndex]
                    },
                    // 以下为是否显示，显示位置和显示格式
                    label: {
                      show: true,

                      position: 'top',
                      //                             formatter: '{c}'
                      // formatter: "{b}\n{c}"
                      formatter: function (params) {
                        var res = params.name + ' : ' + params.data.value
                        return res
                      }
                    }
                  }
                }
              }
              // {
              //   name: "面积模式",
              //   type: "pie",
              //   radius: [30, 110],
              //   center: ["75%", "50%"],
              //   roseType: "area",
              //   data: [
              //     { value: 10, name: "rose1" },
              //     { value: 5, name: "rose2" },
              //     { value: 15, name: "rose3" },
              //     { value: 25, name: "rose4" },
              //     { value: 20, name: "rose5" },
              //     { value: 35, name: "rose6" },
              //     { value: 30, name: "rose7" },
              //     { value: 40, name: "rose8" }
              //   ]
              // }
            ]
          },
          true
        )
      }
    },
    getTagChart: async function () {
      var res = await this.$http.get(
        `/v1/index/TagChart?type=${this.colorTxt}`
      )
      var { code, message, data } = res.data
      if (code == 0) {
        this.piedata = data
        if (this.colorTxt == 0 || this.colorTxt == 1) {
          this.nodes = data.nodes
        }
        if (this.colorTxt == 0 || this.colorTxt == 1) {
          this.edges = data.edges
        }
        setTimeout(() => {
          this.initPlat()
          // console.log(data.nodes)
        }, 200)
      }
    }
  },
  mounted: function () {
    this.getTagChart()
    // console.log('rrrrr', this.newsList)
    // console.log('ooooo', this.otherList)
    this.$store.dispatch('getListByContent')
    this.$store.dispatch('videoInfoGrossCount')
    this.$store.dispatch('getListByTop')
    this.getFlowsList()
    // this.creatCart()
          this.roleId =this.$store.state.userInfo.roleid

  },
  watch: {
    videoGrossCount: function () {
      this.creatCart()
    },
    '$store.state.videoTypeId': function () {
      // this.$store.dispatch("getListByContent");
      // if (this.$store.state.otherList.videoInfoList.length >= 2) {
      //   this.$store.state.otherList.videoInfoList = this.$store.state.otherList.videoInfoList.slice(
      //     0,
      //     2
      //   );
      // }
      // --------
      //   handler(newName, oldName) {
      //     alert(111);
      //     this.$store.dispatch("getListByContent");
      //     if (this.otherList.videoInfoList.length >= 2) {
      //       this.otherList.videoInfoList = this.otherList.videoInfoList.slice(
      //         0,
      //         2
      //       );
      //     }
      //   },
      //    deep:true,
      //  immediate:true
    }
  },
  beforeDestroy: function () {
    this.$store.commit('changeTypeId', '')
  }
}
</script>

<style lang="scss" scoped>
.bg-time {
  background-color: #e7fbf6;
}
.bg-size {
  background-color: #e9fcc6;
}
.bg-total {
  background-color: #ffefdf;
}
.bg-video {
  background-color: #f0efff;
}
.bg-yellow {
  background-color: #f5a623;
}
.bg-gary {
  background-color: #c1c7ce;
}
.bg-tab {
  background-color: #ebedef;
}
.red {
  color: #f45252;
}
.txtColor {
  color: #00aaff;
  font-weight: bold;
}
.nn {
  // border: 1px solid #c1c7ce;

  text-align: left;
  // font-size: 20px;
  // background: #e6e9eb;
  background-color: #e2e8ef;
  font-weight: bold;
  padding: 10px;
  color: #212d38;
  border-radius: 10px 10px 0 0;
  &:hover {
    cursor: pointer;
  }
}
.ranlActive {
  background-color: #fff;
  color: #2a3541;
  border: 1px solid #c1c7ce;
  border-bottom: none;
  // font-size: 22px;
  border-top: 2px solid #00aaff;
}
.topActive {
  background-color: #00aaff;
  color: #fff;
}
// ----
.mh {
  background-color: #f5f5f5;
  height: auto;
  overflow-x: hidden;
  .v_header {
    height: 90px;
    line-height: 90px;
    padding: 0 10px;
    background: rgba(#000, 0.1);
    position: absolute;
    top: 0px;
    z-index: 2;
    .el-input__inner {
      // background-color: red;
      background: rgba(#fff, 0.3);
    }
  }
  .v_image {
    height: 200px;
    width: 100%;
    text-align: center;
    color: #fff;
    background: url("../../assets/img/mhome.jpg") no-repeat;
    background-size: cover;
    position: absolute;
    top: 0px;
    z-index: 1;
    padding-top: 100px;
  }
  .list {
    background-color: #fff;
    .nav-tab {
      display: flex;
      flex-direction: row;
      margin: 20px 20px;
      justify-content: space-around;
      border-radius: 5px;
      border: 2px solid #00aaff;
      .nav-active {
        background-color: #00aaff;
        color: #fff;
      }
      div {
        background-color: #fff;
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: center;
        //   &:hover{
        //       background-color: #00aaff;
        //       color: #fff;
        //   }
      }
    }
    .typeVideoList {
      li {
        float: left;
        width: 50%;
        //   margin-right: 2%;
        padding: 10px;
        height: 250px;
        border-right: 1px solid #eaeaea;
        border-bottom: 1px solid #eaeaea;
        &:nth-child(2n) {
          margin-right: 0px;
        }
        .el-image {
          margin: 10px 0px;
        }
      }
    }
  }
  .data-tab {
    .el-image {
      width: 27px;
      height: 27px;
      vertical-align: middle;
    }
    .tab-box {
      width: 46%;
      height: 8rem;
      display: flex;
      padding: 10px 20px;
      flex-direction: row;
      float: left;
      background-color: #fff;
      margin: 2%;
      border-radius: 5px;
      .tab-img {
        width: 4rem;
        height: 4rem;
        text-align: center;
        line-height: 4rem;
        border-radius: 15px;
        vertical-align: middle;
        align-items: center;
        align-self: center;
      }
    }
  }
  // 重点门类视频数量图标
  .pieCart {
    margin: 10px 15px;
    padding: 10px 0px;
    background-color: #fff;
    height: auto;
    border-radius: 5px;
  }
  #twocart {
    border-radius: 10px;
    padding: 20px 0px;
  }
  #threecart {
    border-radius: 10px;
    padding: 20px 0px;
  }
  // 热数据排行榜
  .top_nav {
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    text-align: center;
    justify-content: space-around;
    margin: 0px 10px;
    div {
      // width: 48%;
    }
  }
  .top_name {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    border: 2px solid #00aaff;

    margin: 10px 20px;
    border-radius: 5px;
    color: #0caeff;
    font-size: 14px;
    li {
      width: 100%;
      height: 100%;
      text-align: center;
      padding: 3px 0px;

      // &:hover {
      //   background-color: #00aaff;
      //   color: #fff;
      // }
    }
  }
  .top-box {
    .top-li {
      display: flex;
      flex-direction: row;
      padding: 20px 10px;
      .li-img {
        position: relative;
        .li-num {
          width: 30px;
          height: 26px;
          border-radius: 5px 0 5px 0;
          // background-color: #f5a623;
          // background-color: #c1c7ce;

          left: 0px;
          top: 0px;
          position: absolute;
          text-align: center;
          color: #fff;
          font-size: 20px;
        }
      }
      .el-image {
        width: 135px;
        height: 96px;
        border-radius: 5px;
      }
      .li-text {
        padding: 0 10px;
      }
    }
  }
  // 平台内容纬度
  .platdata {
    margin-top: 3rem;
    margin: 10px;
    // margin-bottom: 10rem;
    .plat-top-nav {
      .pl-tab {
        width: 100%;
        // height: 5rem;
        padding: 1rem 0px;
        margin: 0px 5px;
        // margin-bottom: 0px;
        text-align: center;
        vertical-align: middle;
        align-items: center;
        // background-color: #ebedef;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        // &:hover {
        //   background-color: #fff;
        // }
      }
    }
    .plat-chart {
      margin: 0px 5px;
      background-color: #fff;
      height: 8rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/mobhome.vue